
import {mapGetters} from 'vuex'

export default {
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ready:false,
    }
  },
  head() {
      if(this.ready) {
        return {
          script: [ { type: 'application/ld+json', json: this.structuredDataBreadcrumbs },]
        }
      }
    },
  computed: {
    ...mapGetters({
      title: 'pages/getPageTitle',
      postTitle: 'posts/getPostTitle'
    }),
    itemsWithHome() {
      const routeItems = this.$route.path.split('/').filter((item) => item)
      console.log('routeItems: ',routeItems)
      const nonRouteItems = ['lists']
      let items

      if (routeItems[0] === 'en-us'){
        items = [
          {
            label: 'US Home',
            url:'/en-us/',
            link: {
              name: '/en-us/'
            }
          }
        ]
        routeItems.shift()
      }
      else if (routeItems[0] === 'ie'){
        items = [
          {
            label: 'Ireland Home',
            url:'/ie/',
            link: {
              name: '/ie/'
            }
          }
        ]
        routeItems.shift()
      }
      else if (routeItems[0] === 'au'){
        items = [
          {
            label: 'Australia Home',
            url:'/au/',
            link: {
              name: '/au/'
            }
          }
        ]
        routeItems.shift()
      }
      else if (routeItems[0] === 'ca'){
        items = [
          {
            label: 'Canada Home',
            url:'/ca/',
            link: {
              name: '/ca/'
            }
          }
        ]
        routeItems.shift()
      }
      else if (routeItems[0] === 'za'){
        items = [
          {
            label: 'South Africa Home',
            url:'/za/',
            link: {
              name: '/za/'
            }
          }
        ]
        routeItems.shift()
      }
      else {
      items = [
        {
          label: 'Home',
          url:'/',
          link: {
            name: '/'
          }
        },
      ]
      }

      // Build breadcrumb items with links
      // console.log(routeItems)
      // console.log('This Page: ', this.page)
      routeItems.forEach((routeItem, index) => {
        const fixedItem = routeItem.replace(/-/g,' ')
       let item
        if (index === 0) {
          items.push({
            label: fixedItem,
            url: items[0].url === "/en-us/" || items[0].url === "/ie/" || items[0].url === "/au/" || items[0].url === "/ca/" || items[0].url === "/za/" ? this.$route.path.split('/').slice(0,index+3).join('/')+'/': this.$route.path.split('/').slice(0,index+2).join('/')+'/'
          })
        }

        else if (index === routeItems.length-1){
           item = {
            label: this.title || this.postTitle || fixedItem
          }
          if (!nonRouteItems.includes(routeItem)) {
            item.url = items[0].url === "/en-us/" || items[0].url === "/ie/" || items[0].url === "/au/" || items[0].url === "/ca/" || items[0].url === "/za/" ? this.$route.path.split('/').slice(0,index+3).join('/')+'/': this.$route.path.split('/').slice(0,index+2).join('/')+'/'
          }
           items.push(item)
        }
         else {
           item = {
            label: fixedItem
          }

          if (!nonRouteItems.includes(routeItem)) {
            item.url = items[0].url === "/en-us/" || items[0].url === "/ie/" || items[0].url === "/au/" || items[0].url === "/ca/" || items[0].url === "/za/" ? this.$route.path.split('/').slice(0,index+3).join('/')+'/': this.$route.path.split('/').slice(0,index+2).join('/')+'/'
          }
          items.push(item)
        }
      })

      return items
    },
    breadcrumbItemList() {
      const list = []
      if(this.itemsWithHome.length > 0) {
        this.itemsWithHome.forEach((item, index) => {
          list.push({
                    "@type":"ListItem",
                    "position": index+1,
                    "name": item.label === "US Home" ? "US Home" : this.$nuxt.$options.filters.capitalizeWords(item.label),
                    "item": `https://www.tefl.org${item.url}`
                  })
        })


      }

      return list
    },
    structuredDataBreadcrumbs() {
      return {
        "@context": "https://schema.org",
        "@type":"BreadcrumbList",
        "@id":`https://www.tefl.org${this.$route.path}`,
        "itemListElement":this.breadcrumbItemList
      }
  }
  },
  mounted() {
    this.ready = true
  }
}
